export function getElemsByXPath(document: Document, root: HTMLElement, xpath: string): Array<HTMLElement> {
    const ret = new Array<HTMLElement>();

    const elems = document.evaluate(xpath, root, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);

    for (let idx = 0; idx < elems.snapshotLength; idx++) {
        let target = elems.snapshotItem(idx) as HTMLElement;
        if (target.nodeType == Node.ATTRIBUTE_NODE) {
            target = (target as unknown as Attr).ownerElement! as HTMLElement;
        }

        ret.push(target);
    }

    return ret;
}

export function hasElementsByXPathList(root: HTMLElement, xpaths: Array<string>): boolean {
    for (const xpath of xpaths) {
        const resp = root.ownerDocument
            .evaluate(xpath, root, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);

        if (resp.singleNodeValue != null) {
            return true;
        }
    }
    return false
}


export function isParentForElem(elem: HTMLElement, parent: HTMLElement): boolean {
    let curElem: HTMLElement | null = elem;
    while (curElem) {
        if (curElem == parent) {
            return true
        }

        curElem = curElem.parentElement;
    }

    return false;
}


export function getBlockElem(elem: HTMLElement, extendPointElem: HTMLElement): HTMLElement | null {
    let curElem: HTMLElement | null = elem;
    let lastElem: HTMLElement | null = null

    while (curElem) {
        if (curElem == extendPointElem) {
            return lastElem;
        }

        lastElem = curElem;
        curElem = curElem.parentElement;
    }

    return null;
}

export function concatXpath(base: string, tail: string): string {
    if (!base.endsWith("/")) {
        base = base + "/"
    }

    if (tail.startsWith("/")) {
        tail = tail.substring(1);
    }
    return base + tail;
}

/*
Возвращает сам элемент и список родителей, которые содержат только этот элемент. Все эти элементы на странице,
скорее всего, занимают одинаковую область, поэтому при клике на элемент желательно рассматривать все подобные
элементы, а не только самый верхний.
*/
export function getIdentityParents(elem: HTMLElement, maxParent?: HTMLElement): Array<HTMLElement> {
    const ret = [elem];

    if (!maxParent) {
        maxParent = elem.ownerDocument.getRootNode() as HTMLElement;
    }

    let curElem = elem.parentElement;
    while (curElem) {
        if (curElem == maxParent) {
            break
        }

        let textElemCount = 0;
        for (const node of curElem.childNodes) {
            if (node.nodeType == Node.TEXT_NODE && node.textContent && node.textContent.trim() != "") {
                textElemCount += 1;
            }
        }

        if (curElem.childElementCount > 1 || textElemCount > 0) {
            break;
        }

        ret.push(curElem);
        curElem = curElem.parentElement;
    }

    return ret;
}

// возвращает список родителей для элемента
export function getParents(elem: HTMLElement, maxParent?: HTMLElement): Array<HTMLElement> {
    const ret = [elem];

    if (!maxParent) {
        maxParent = elem.ownerDocument.getRootNode() as HTMLElement;
    }

    let curElem = elem.parentElement;
    while (curElem) {
        if (curElem == maxParent) {
            break
        }

        let textElemCount = 0;
        for (const node of curElem.childNodes) {
            if (node.nodeType == Node.TEXT_NODE && node.textContent && node.textContent.trim() != "") {
                textElemCount += 1;
            }
        }

        ret.push(curElem);
        curElem = curElem.parentElement;
    }

    return ret;
}


// todo: merge with getIdentityParents
export function getIdentityChilds(elem: HTMLElement): Array<HTMLElement> {
    const ret = [elem];

    let curElem = elem;
    while (curElem) {
        let textElemCount = 0;
        for (const node of curElem.childNodes) {
            if (node.nodeType == Node.TEXT_NODE && node.textContent && node.textContent.trim() != "") {
                textElemCount += 1;
            }
        }

        if (curElem.childElementCount > 1 || textElemCount > 0) {
            break;
        }

        ret.push(curElem);
        curElem = curElem.children[0] as HTMLElement;
    }

    return ret;
}
